const liffID = '1654113555-J8zLeYXP'
const liffURL = 'https://liff.line.me/' + liffID

export {
    liffID,
    liffURL
}